export class Observable {
    constructor() {
        this.listeners = [];
        this.listen = (listener, context) => {
            this.listeners.push({ l: listener, c: context });
        };
        this.stopListen = (listener) => {
            const index = this.listeners.findIndex((l) => l.l === listener);
            if (index !== -1) {
                this.listeners.splice(index, 1);
            }
        };
        this.stopAllListen = () => {
            this.listeners.length = 0;
        };
        this.notifyAll = (v, context) => {
            this.listeners.forEach((l) => {
                if (context && l.c === context) {
                    return;
                }
                l.l(v);
            });
        };
        this.link = (other) => {
            this.listen((v) => other.notifyAll(v, this), other);
            other.listen((v) => this.notifyAll(v, other), this);
        };
        this.unlink = (other) => {
            this.stopListen(other.notifyAll);
            other.stopListen(this.notifyAll);
        };
    }
}
